/**
 * Valida um CNPJ, incluindo o novo formato alfanumérico (NT 2025.002)
 * @param {string} cnpj - CNPJ formatado ou não (ex: "12.ABC.345/01DE-35")
 * @returns {boolean} true se o CNPJ for válido
 */
export function validateCnpj(cnpj) {
  if (!cnpj) return false;

  cnpj = String(cnpj).replace(/[^0-9A-Za-z]/g, '').toUpperCase();

  // Verifica se o CNPJ tem 14 caracteres
  if (cnpj.length !== 14) {
    return false;
  }

  // Verifica se todos os caracteres são iguais (CNPJ inválido se for verdadeiro)
  if (/^(.)\1+$/.test(cnpj)) {
    return false;
  }

  // Os dígitos verificadores são sempre numéricos
  if (!/^\d{2}$/.test(cnpj.substring(12))) {
    return false;
  }

  // Calcula o primeiro dígito verificador
  let soma = 0;
  let peso = 2;
  for (let i = 11; i >= 0; i--) {
    soma += (cnpj.charCodeAt(i) - 48) * peso;
    peso = peso === 9 ? 2 : peso + 1;
  }
  const digito1 = (soma % 11 < 2) ? 0 : 11 - (soma % 11);

  if (digito1 !== parseInt(cnpj.charAt(12))) {
    return false;
  }

  // Calcula o segundo dígito verificador
  soma = 0;
  peso = 2;
  for (let i = 12; i >= 0; i--) {
    soma += (cnpj.charCodeAt(i) - 48) * peso;
    peso = peso === 9 ? 2 : peso + 1;
  }
  const digito2 = (soma % 11 < 2) ? 0 : 11 - (soma % 11);

  return digito2 === parseInt(cnpj.charAt(13));
}

/**
 * Regra de validação de CNPJ para campos do Vuetify
 * @param {string} v - Valor digitado no campo
 * @returns {true|string} true se válido, ou mensagem de erro
 */
export function cnpjRule(v) {
  return validateCnpj(v) || 'CNPJ Inválido';
}
